import { getBankacctList } from "src/apis/bankacctApi";
import { getCommonCodeList, getConditionCodeList, getMajorCodeOptions, getMinorCodeList } from "src/apis/commonCodeApi";
import { getCompanyList } from "src/apis/companyApi";
import { getCustomerList } from "src/apis/customerApi";
import { getEmployeeList } from "src/apis/employeeApi";
import { getEquipmentList } from "src/apis/equipmentApi";
import { getItemAllList, getItemPopupList } from "src/apis/itemApi";
import { getMenuModalList } from "src/apis/menuApi";
import { getOrganizationList } from "src/apis/organizaApi";
import { getBookmarkList } from "src/apis/userApi";
import { getAllWarehouses } from "src/apis/warehouseApi";
import { getAllWorkPlaces } from "src/apis/workPlaceApi";
import { getMST4010_R01List } from "src/containers/mes/MST/MST4010_R01/Api_MST4010_R01";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { CompanyDto } from "src/dtos/company/companyDto";
import { CustomerResponseDto } from "src/dtos/customer/customerResponseDto";
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { MenuDto } from "src/dtos/menu/menuDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { ItemDto } from "src/types/base";
import { BankAcctDto } from "src/utils/bank/bankacctDto";
import { create } from "zustand";

export interface BookmarkCdList {
	key: string;
	name: string;
	type: string;
}

export interface CommonCodeStore {

	
	// 공통코드 관련
	majorCodeList: SysCodeDto[];
	setMajorCodeList: (list: SysCodeDto[], withFilteredList?: boolean) => void;

	fetchBankacctCdCode: () => Promise<BankAcctDto[]>;
	fetchCommonCode: () => Promise<void>;
	fetchCustomCdCode: () => Promise<CustomerResponseDto[]>;
	fetchCompCdCode: () => Promise<CompanyDto[]>;
	fetchEmployeeCdCode: () => Promise<EmployeeDto[]>;
	fetchEquipmentCdCode: () => Promise<EquipmentDto[]>;
	fetchMenuCdCode: () => Promise<MenuDto[]>;
	fetchBookmarkCdCode: () => Promise<BookmarkCdList[]>;
	fetchOrgCdCode: () => Promise<OrganizationDto[]>;
	fetchWarehouseCdCode: () => Promise<WareHouseDto[]>;
	fetchWorkPlaceCdCode: () => Promise<WorkPlaceDto[]>;
	fetchItemCdCode: () => Promise<Map<string, ItemDto>>;


	// 초기화
	initData: () => void;

	// 지역코드
	areaCdList: SysCodeDto[];				setAreaCdList: (data: SysCodeDto[]) => void;
	// 거래유형
	customTypeList: SysCodeDto[];			setCustomTypeList: (data: SysCodeDto[]) => void;
	// 시스템권한
	autGroupList: SysCodeDto[];			setAutGroupList: (data: SysCodeDto[]) => void;
	// 사용구분 
	actionTypeList: SysCodeDto[];			setActionTypeList: (data: SysCodeDto[]) => void;
	// 생년월일 타입 코드
	birthdayTypeList: SysCodeDto[];		setBirthdayTypeList: (data: SysCodeDto[]) => void;
	// 은행코드
	bankCdList: SysCodeDto[];				setBankCdList: (data: SysCodeDto[]) => void;
	// 계좌유형
	bankAcctTypeList: SysCodeDto[];		setBankAcctTypeList: (data: SysCodeDto[]) => void;
	// 브랜드코드
	brandCdList: SysCodeDto[];				setBrandCdList: (data: SysCodeDto[]) => void;
	// 국가 코드
	countryCdList: SysCodeDto[];				setCountryCdList: (data: SysCodeDto[]) => void;
	// 보유차량 타입 코드
	carTypeList: SysCodeDto[];				setCarTypeList: (data: SysCodeDto[]) => void;
	// 차량모델 코드
	carModelList: SysCodeDto[];			setCarModelList: (data: SysCodeDto[]) => void;
	// 금형세척구분
	cleanTypeList: SysCodeDto[];			setCleanTypeList: (data: SysCodeDto[]) => void;
	// 입사유형
	compJoinTpList: SysCodeDto[];			setCompJoinTpList: (data: SysCodeDto[]) => void;
	// 데이터수집주기
	cycleList: SysCodeDto[];				setCycleList: (data: SysCodeDto[]) => void;
	// 개발상태
	devStsList: SysCodeDto[];				setDevStsList: (data: SysCodeDto[]) => void;
	// 대시보드 타입
	dashboardTypeList: SysCodeDto[];		setDashboardTypeList: (data: SysCodeDto[]) => void;
	// 개발자
	devloperList: SysCodeDto[];			setDevloperList: (data: SysCodeDto[]) => void;
	// 비가동사유
	downtimeValueList: SysCodeDto[];		setDowntimeValueList: (data: SysCodeDto[]) => void;
	// 최종학력 구분
	educationTypeList: SysCodeDto[];		setEducationTypeList: (data: SysCodeDto[]) => void;
	// 재직상태
	empstsCdList: SysCodeDto[];			setEmpstsCdList: (data: SysCodeDto[]) => void;
	// 설비분류
	eqmClassList: SysCodeDto[];			setEqmClassList: (data: SysCodeDto[]) => void;
	// 설비유형
	eqmTypeList: SysCodeDto[];				setEqmTypeList: (data: SysCodeDto[]) => void;
	// 설비상태
	eqmStatusList: SysCodeDto[];			setEqmStatusList: (data: SysCodeDto[]) => void;
	// 검사결과
	faultyValueList: SysCodeDto[];			setFaultyValueList: (data: SysCodeDto[]) => void;
	// 외관검사 판정
	okNgList: SysCodeDto[];					setOkNgList: (data: SysCodeDto[]) => void;
	// 금형분류
	moldClassList: SysCodeDto[];			setMoldClassList: (data: SysCodeDto[]) => void;
	// 금형유형
	moldTypeList: SysCodeDto[];			setMoldTypeList: (data: SysCodeDto[]) => void;
	// 화페코드
	moneyCdList: SysCodeDto[];				setMoneyCdList: (data: SysCodeDto[]) => void;
	// 자재공급구분
	materialIntypeList: SysCodeDto[];		setMaterialIntypeList: (data: SysCodeDto[]) => void;
	// 내외부구분
	inoutBoundList: SysCodeDto[];			setInoutBoundList: (data: SysCodeDto[]) => void;
	// 수불구분 - 배송방법
	inoutClassList: SysCodeDto[];			setInoutClassList: (data: SysCodeDto[]) => void;
	// 수불방법 - 출고구분
	inoutMethodList: SysCodeDto[];			setInoutMethodList: (data: SysCodeDto[]) => void;
	// 이자유형
	interesttypeList: SysCodeDto[];		setInteresttypeList: (data: SysCodeDto[]) => void;
    //설비점검 상태
	inspectionStatusList: SysCodeDto[];	setInspectionStatusList: (data: SysCodeDto[]) => void;
	// 검사결과
	inspectionResultList: SysCodeDto[];	setInspectionResultList: (data: SysCodeDto[]) => void;
	// 검사범위구분
	inspectionRangeList: SysCodeDto[];	setInspectionRangeList: (data: SysCodeDto[]) => void;
	// 검사구분 (신규)
	inspectionTypeList: SysCodeDto[];		setInspectionTypeList: (data: SysCodeDto[]) => void;
	// 검사값유형 (신규 - INSPECTION_VALUE)
	inspectionValueList: SysCodeDto[];		setInspectionValueList: (data: SysCodeDto[]) => void;
	// 검사방법 (신규 - INSPECTION_METHOD)
	inspectMethodList: SysCodeDto[];		setInspectMethodList: (data: SysCodeDto[]) => void;
	// 검사방법
	inspectClassList: SysCodeDto[];		setInspectClassList: (data: SysCodeDto[]) => void;
	// 아이템계정
	itemAccountList: SysCodeDto[];			setItemAccountList: (data: SysCodeDto[]) => void;
	// 아이템그룹
	itemGroupList: SysCodeDto[];			setItemGroupList: (data: SysCodeDto[]) => void;
	// 출고물류상태
	itemStatusList: SysCodeDto[];			setItemStatusList: (data: SysCodeDto[]) => void;
	// 직책
	jcCdList: SysCodeDto[];				setJcCdList: (data: SysCodeDto[]) => void;
	//작업조
	jobTeamList: SysCodeDto[];				setJobTeamList: (data: SysCodeDto[]) => void;
	// 직종(직군)
	jjCdList: SysCodeDto[];				setJjCdList: (data: SysCodeDto[]) => void;
	// 직위
	jwCdList: SysCodeDto[];				setJwCdList: (data: SysCodeDto[]) => void;
	// KPI 구분
	kpiKeyList: SysCodeDto[];				setKpiKeyList: (data: SysCodeDto[]) => void;
	// 레이어
	layerList: SysCodeDto[];				setLayerList: (data: SysCodeDto[]) => void;
	// 작업지시구분
	ordTypeList: SysCodeDto[];				setOrdTypeList: (data: SysCodeDto[]) => void;
	// 수금/지불 방법
	paycollectList: SysCodeDto[];			setPaycollectList: (data: SysCodeDto[]) => void;
	// 수금/지불 기준
	paycollectTargetList: SysCodeDto[];	setPaycollectTargetList: (data: SysCodeDto[]) => void;
	// 급여구분
	payTpList: SysCodeDto[];				setPayTpList: (data: SysCodeDto[]) => void;
	// 도금구분
	platingTypeList: SysCodeDto[];			setPlatingTypeList: (data: SysCodeDto[]) => void;
	// 프로그램정보
	programList: SysCodeDto[];				setProgramList: (data: SysCodeDto[]) => void;
	// 퇴직사유 - 퇴사구분 리스트
	retireTypeList: SysCodeDto[];			setRetireTypeList: (data: SysCodeDto[]) => void;
	// 시스템
	systemList: SysCodeDto[];				setSystemList: (data: SysCodeDto[]) => void;
	// 검사구분 (TEST_CLASS)
	testClassCodeList: SysCodeDto[];		setTestClassCodeList: (data: SysCodeDto[]) => void;
	// 단위
	unitList: SysCodeDto[];					setUnitList: (data: SysCodeDto[]) => void;
	// 부가세 유형
	vatTypeList: SysCodeDto[];				setVatTypeList: (data: SysCodeDto[]) => void;
	// 세금계산서 납입여부
	vatIoFlagList: SysCodeDto[];			setVatIoFlagList: (data: SysCodeDto[]) => void;
	// 작업공정유형
	workProcessList: SysCodeDto[];			setWorkProcessList: (data: SysCodeDto[]) => void;
	// 물류
	wmsCdList: SysCodeDto[];				setWmsCdList: (data: SysCodeDto[]) => void;
	// 입고구분
	wmsInTypeCdList: SysCodeDto[];			setWmsInTypeCdList: (data: SysCodeDto[]) => void;
	// 출고구분
	wmsOutTypeCdList: SysCodeDto[]; 		setWmsOutTypeCdList: (data: SysCodeDto[]) => void;
	// 입고분류
	inoutTypeList: SysCodeDto[];			setInoutTypeList: (data: SysCodeDto[]) => void;
	// 약품유형
	chemicalTypeList: SysCodeDto[];			setChemicalTypeList: (data: SysCodeDto[]) => void;
	sparesTypeList: SysCodeDto[];			setSparesTypeList: (data: SysCodeDto[]) => void;
	// 생산재고 발생기준
	prodStockTypeList: SysCodeDto[];		setProdStockTypeList: (data: SysCodeDto[]) => void;
	// yes/no
	yesNoList: SysCodeDto[];				setYesNoList: (data: SysCodeDto[]) => void;
	// yes/no 숫자
	yesNoNumList: SysCodeDto[];			setYesNoNumList: (data: SysCodeDto[]) => void;

	// 계좌 코드
	bankacctCdList: BankAcctDto[];				setBankacctCdList: (data: BankAcctDto[]) => void;
	// 즐겨찾기 코드
	bookmarkCdList: BookmarkCdList[];			setBookmarkCdList: (data: BookmarkCdList[]) => void;
	// 거래처 코드
	customCdList: CustomerResponseDto[];		setCustomCdList: (data: CustomerResponseDto[]) => void;
	// 사업장 코드
	compCdList: CompanyDto[];					setCompCdList: (data: CompanyDto[]) => void;
	// 설비 코드
	equipmentCdList: EquipmentDto[];			setEquipmentCdList: (data: EquipmentDto[]) => void;
	// 사원 코드
	employeeCdList: EmployeeDto[];				setEmployeeCdList: (data: EmployeeDto[]) => void;
	// 메뉴 코드
	menuCdList: MenuDto[];						setMenuCdList: (data: MenuDto[]) => void;
	// 조직 코드
	orgCdList: OrganizationDto[];				setOrgCdList: (data: OrganizationDto[]) => void;
	// 창고 코드
	warehouseCdList: WareHouseDto[];			setWarehouseCdList: (data: WareHouseDto[]) => void;
	// 공정 정보 코드
	workPlaceList: WorkPlaceDto[];				setWorkPlaceList: (data: WorkPlaceDto[]) => void;

	// 품목 코드(검증용이므로 검색속도 가속화하게 맵으로 저장)
	itemCdMap: Map<string, ItemDto>;			setItemCdMap: (data: Map<string, ItemDto>) => void;

	plcaddressList: SysCodeDto[];			setPlcaddressList: (data: SysCodeDto[]) => void;

	bookMarkCd: string;
	
	// 검색 조건 관련 상태 추가
	searchCondition: {
		majorCd: string;
		minorCd: string;
		codeNm: string;
	};
	setSearchCondition: (condition: { majorCd?: string; minorCd?: string; codeNm?: string }) => void;
	resetSearchCondition: () => void;

	// 선택된 메이저코드에 따른 상세코드 리스트
	minorCodeOptions: SysCodeDto[];
	setMinorCodeOptions: (options: SysCodeDto[]) => void;
	fetchMinorCodeOptions: (majorCd: string) => Promise<void>;

	// 검색조건용 상세코드 관련
	conditionCodeOptions: SysCodeDto[];
	setConditionCodeOptions: (options: SysCodeDto[]) => void;
	fetchConditionCodeOptions: (majorCd: string) => Promise<void>;

	// 메이저코드 드롭다운 옵션 관련
	majorCodeOptions: SysCodeDto[];
	setMajorCodeOptions: (options: SysCodeDto[]) => void;
	fetchMajorCodeOptions: () => Promise<void>;
}

/** useCommonCodeStore에 등록된 배열(List) 상태 키 모두 등록 */
export type CommonCodeRequirementKey = {
	[K in keyof CommonCodeStore]: CommonCodeStore[K] extends unknown[] ? K : never;
}[keyof CommonCodeStore];

export const allCd: SysCodeDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	majorCd: '',
	minorCd: '',
	codeNm: '',
	sysFlg: '',
	dispSeq: 0,
	ref01: '',
	ref02: '',
	ref03: '',
	ref04: '',
	ref05: '',
	ref06: '',
	ref07: '',
	ref08: '',
	ref09: '',
	ref10: '',
	remark: '',
	insertDt: new Date(),
	insertUser: ``,
	insertForm: ``,
	updateDt: new Date(),
	updateUser: ``,
	updateForm: ``,

	inserted: false,
	isModified: false,
	originalData: undefined,
}


export const useCommonCodeStore = create<CommonCodeStore>((set) => ({

	
	majorCodeList: [],
	setMajorCodeList: (list: SysCodeDto[], withFilteredList?: boolean) => set((state) => ({
		...state,
		majorCodeList: list,

	})),

	fetchCommonCode: async () => {

		const [
			majorCodeListRes,
			areaCdListRes,
			customTypeListRes,
			autGroupListRes,
			actionTypeListRes,
			birthdayTypeListRes,
			bankCdListRes,
			bankAcctTypeListRes,
			brandCdListRes,
			countryCdListRes,
			carTypeListRes,
			carModelListRes,
			cleanTypeListRes,
			compJoinTpListRes,
			cycleListRes,
			dashboardTypeListRes,
			devStsListRes,
			devloperListRes,
			downtimeValueListRes,
			educationTypeListRes,
			empstsCdListRes,
			eqmClassListRes,
			eqmTypeListRes,
			eqmStatusListRes,
			faultyValueListRes,
			okNgListRes,
			moldClassListRes,
			moldTypeListRes,
			moneyCdListRes,
			materialIntypeListRes,
			inoutBoundListRes,
			inoutClassListRes,
			inoutMethodListRes,
			interesttypeListRes,
			inspectionStatusListRes,
			inspectionResultListRes,
			inspectionRangeListRes,
			inspectionTypeListRes,
			inspectionValueListRes,
			inspectMethodListRes,
			inspectClassListRes,
			itemAccountListRes,
			itemGroupListRes,
			itemStatusListRes,
			jcCdListRes,
			jobTeamListRes,
			jjCdListRes,
			jwCdListRes,
			layerListRes,
			ordTypeListRes,
			paycollectListRes,
			paycollectTargetListRes,
			payTpListRes,
			platingTypeListRes,
			programListRes,
			retireTypeListRes,
			systemListRes,
			testClassCodeListRes,
			unitListRes,
			vatTypeListRes,
			vatIoFlagListRes,
			wmsCdListRes,
			wmsInTypeCdListRes,
			wmsOutTypeCdListRes,
			workProcessListRes,
			prodStockTypeListRes,
			yesNoListRes,
			yesNoNumListRes,
			kpiKeyListRes, // 1. API 호출 결과를 받을 변수 추가
			plcaddressListRes,
			inoutTypeListRes,
			chemicalTypeListRes,
			sparesTypeListRes,
		] = await Promise.all([
			getCommonCodeList(),
			getMinorCodeList('AREACD'),
			getMinorCodeList('CUSTOM_TYPE'),
			getMinorCodeList('AUTGROUP'),
			getMinorCodeList('ACTIONTYPE'),
			getMinorCodeList('CALENDARTYPE'),
			getMinorCodeList('BANKCD'),
			getMinorCodeList('BANKACCTTYPE'),
			getMinorCodeList('BRANDCD'),
			getMinorCodeList('COUNTRY'),
			getMinorCodeList('CARTYPE'),
			getMinorCodeList('CARMODEL'),
			getMinorCodeList('CLEANT_TYPE'),
			getMinorCodeList('COMPJOINTP'),
			getMinorCodeList('CYCLE'),
			getMinorCodeList('DASHBOARD_TYPE'),
			getMinorCodeList('DEVSTS'),
			getMinorCodeList('DEVLOPER'),
			getMinorCodeList('DOWNTIME_VALUE'),
			getMinorCodeList('EDUCATION'),
			getMinorCodeList('EMPSTS'),
			getMinorCodeList('EQMCLASS'),
			getMinorCodeList('EQMTYPE'),
			getMinorCodeList('EQMSTATUS'),
			getMinorCodeList('FAULTY_VALUE'),
			getMinorCodeList('OKNG'),
			getMinorCodeList('MOLD_CLASS'),
			getMinorCodeList('MOLD_TYPE'),
			getMinorCodeList('MONEYCD'),
			getMinorCodeList('MATERIAL_INTYPE'),
			getMinorCodeList('INOUTBOUND'),
			getMinorCodeList('INOUT_CLASS'),
			getMinorCodeList('INOUT_METHOD'),
			getMinorCodeList('INTERESTYPE'),
			getMinorCodeList('INSPECTION_STATUS'),
			getMinorCodeList('INSPECTION_RESULT'),
			getMinorCodeList('INSPECTION_RANGE'),
			getMinorCodeList('INSPECTION_TYPE'),
			getMinorCodeList('INSPECTION_VALUE'),
			getMinorCodeList('INSPECTION_METHOD'),
			getMinorCodeList('INSPECT_CLASS'),
			getMinorCodeList('ITEMACCOUNT'),
			getMinorCodeList('ITEMGROUP'),
			getMinorCodeList('ITEM_STATUS'),
			getMinorCodeList('JCCD'),
			getMinorCodeList('JOBTEAM'),
			getMinorCodeList('JJCD'),
			getMinorCodeList('JWCD'),
			getMinorCodeList('LAYER'),
			getMinorCodeList('ORDTYPE'),
			getMinorCodeList('PAYCOLLECT'),
			getMinorCodeList('PAYCOLLECTCOMP'),
			getMinorCodeList('PAYTP'),
			getMinorCodeList('PLATING_TYPE'),
			getMinorCodeList('PROGRAM'),
			getMinorCodeList('RETIRETYPE'),
			getMinorCodeList('SYSTEM'),
			getMinorCodeList('TEST_CLASS'),
			getMinorCodeList('UNIT'),
			getMinorCodeList('VATTYPE'),
			getMinorCodeList('VAT_IO_FLAG'),
			getMinorCodeList('WMSCD'),
			getMinorCodeList('WMSINTYPE'),
			getMinorCodeList('WMSOUTTYPE'),
			getMinorCodeList('WORKPROCESS'),
			getMinorCodeList('PROD_STOCK_TYPE'),
			getMinorCodeList('YESNO'),
			getMinorCodeList('YESNO_NUM'),
			getMinorCodeList('KPIKEY'),
			getMinorCodeList('PLCADDRESS'),
			getMinorCodeList('INOUTTYPE'),
			getMinorCodeList('CHEMICAL_TYPE'),
			getMinorCodeList('SPARES_TYPE'),
		]);
		set({
			majorCodeList:			majorCodeListRes.data.data,
			areaCdList:				areaCdListRes.data.data,
			customTypeList:		customTypeListRes.data.data,
			autGroupList:			autGroupListRes.data.data,
			actionTypeList:			actionTypeListRes.data.data,
			birthdayTypeList:		birthdayTypeListRes.data.data,
			bankCdList:				bankCdListRes.data.data,
			bankAcctTypeList:		bankAcctTypeListRes.data.data,
			brandCdList:			brandCdListRes.data.data,
			countryCdList:			countryCdListRes.data.data,
			carTypeList:			carTypeListRes.data.data,
			carModelList:			carModelListRes.data.data,
			cleanTypeList:			cleanTypeListRes.data.data,
			compJoinTpList:			compJoinTpListRes.data.data,
			cycleList:				cycleListRes.data.data,
			dashboardTypeList:		dashboardTypeListRes.data.data,
			devStsList:				devStsListRes.data.data,
			devloperList:			devloperListRes.data.data,
			downtimeValueList:		downtimeValueListRes.data.data,
			educationTypeList:		educationTypeListRes.data.data,
			empstsCdList:			empstsCdListRes.data.data,
			eqmClassList:			eqmClassListRes.data.data,
			eqmTypeList:			eqmTypeListRes.data.data,
			eqmStatusList:			eqmStatusListRes.data.data,
			faultyValueList:		faultyValueListRes.data.data,
			okNgList:				okNgListRes.data.data,
			moldClassList:			moldClassListRes.data.data,
			moldTypeList:			moldTypeListRes.data.data,
			moneyCdList:			moneyCdListRes.data.data,
			materialIntypeList:		materialIntypeListRes.data.data,
			inoutBoundList:			inoutBoundListRes.data.data,
			inoutClassList:			inoutClassListRes.data.data,
			inoutMethodList:		inoutMethodListRes.data.data,
			interesttypeList:		interesttypeListRes.data.data,
			inspectionStatusList:	inspectionStatusListRes.data.data,
			inspectionResultList:	inspectionResultListRes.data.data,
			inspectionRangeList:	inspectionRangeListRes.data.data,
			inspectionTypeList:		inspectionTypeListRes.data.data,
			inspectionValueList:	inspectionValueListRes.data.data,
			inspectMethodList:		inspectMethodListRes.data.data,
			inspectClassList:		inspectClassListRes.data.data,
			itemAccountList:		itemAccountListRes.data.data,
			itemGroupList:			itemGroupListRes.data.data,
			itemStatusList:			itemStatusListRes.data.data,
			jcCdList:				jcCdListRes.data.data,
			jobTeamList:			jobTeamListRes.data.data,
			jjCdList:				jjCdListRes.data.data,
			jwCdList:				jwCdListRes.data.data,
			layerList:				layerListRes.data.data,
			ordTypeList:			ordTypeListRes.data.data,
			paycollectList:			paycollectListRes.data.data,
			paycollectTargetList:	paycollectTargetListRes.data.data,
			payTpList:				payTpListRes.data.data,
			platingTypeList:		platingTypeListRes.data.data,
			programList:			programListRes.data.data,
			retireTypeList:			retireTypeListRes.data.data,
			systemList:				systemListRes.data.data,
			testClassCodeList:		testClassCodeListRes.data.data,
			unitList:				unitListRes.data.data,
			vatTypeList:			vatTypeListRes.data.data,
			vatIoFlagList:			vatIoFlagListRes.data.data,
			wmsCdList:				wmsCdListRes.data.data,
			wmsInTypeCdList:		wmsInTypeCdListRes.data.data,
			wmsOutTypeCdList:		wmsOutTypeCdListRes.data.data,
			workProcessList:		workProcessListRes.data.data,
			prodStockTypeList:		prodStockTypeListRes.data.data,
			yesNoList:				yesNoListRes.data.data,
			yesNoNumList:			yesNoNumListRes.data.data,
			kpiKeyList:				kpiKeyListRes.data.data, // 2. 받아온 결과를 스토어 상태에 저장
			plcaddressList:			plcaddressListRes.data.data,
			inoutTypeList:			inoutTypeListRes.data.data,
			chemicalTypeList:		chemicalTypeListRes.data.data,
			sparesTypeList:			sparesTypeListRes.data.data,
		});
	},

	fetchBankacctCdCode: async () => {
		const [ bankacctCdListRes, ] = await Promise.all([ getBankacctList(''), ]);
		const newList = bankacctCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ bankacctCdList: newList, });
		} else {
			set({ bankacctCdList: [] });
		}
		return newList;
	},
	fetchBookmarkCdCode: async () => {
		const [ bookmarkCdListRes, ] = await Promise.all([ getBookmarkList(), ]);
		const newList = bookmarkCdListRes.data.data;

		if (Array.isArray(newList)) {
			set({ bookmarkCdList: newList });
		} else {
			set({ bookmarkCdList: [] });
		}
		return newList;
	},
	fetchCustomCdCode: async () => {
		const [ customCdListRes, ] = await Promise.all([ getCustomerList('all'), ]);
		const newList = customCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ customCdList: newList, });
		} else {
			set({ customCdList: [] });
		}
		return newList;
	},

	fetchCompCdCode: async () => {
		const [ compCdListRes, ] = await Promise.all([ getCompanyList(), ]);
		const newList = compCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ compCdList: newList, });
		} else {
			set({ compCdList: [] });
		}
		return newList;
	},
	fetchEmployeeCdCode: async () => {
		const [ employeeCdListRes, ] = await Promise.all([ getEmployeeList(), ]);
		const newList = employeeCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ employeeCdList: newList, });
		} else {
			set({ employeeCdList: [] });
		}
		return newList;
	},
	fetchEquipmentCdCode: async () => {
		const [ equipmentCdListRes, ] = await Promise.all([ getEquipmentList(), ]);
		const newList = equipmentCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ equipmentCdList: newList, });
		} else {
			set({ equipmentCdList: [] });
		}
		return newList;
	},
	fetchMenuCdCode: async () => {
		const [ menuCdListRes, ] = await Promise.all([ getMenuModalList(), ]);
		const newList = menuCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ menuCdList: newList, });
		} else {
			set({ menuCdList: [] });
		}
		return newList;
	},
	fetchOrgCdCode: async () => {
		const [ orgCdListRes, ] = await Promise.all([ getOrganizationList(), ]);
		const newList = orgCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ orgCdList: newList, });
		} else {
			set({ orgCdList: [] });
		}
		return newList;
	},
	fetchWarehouseCdCode: async () => {
		const [ warehouseCdListRes, ] = await Promise.all([ getAllWarehouses(), ]);
		const newList = warehouseCdListRes.data.data;
		if (Array.isArray(newList)) {
			set({ warehouseCdList: newList, });
		} else {
			set({ warehouseCdList: [] });
		}
		return newList;
	},
	fetchWorkPlaceCdCode: async () => {
		const [ workPlaceListRes, ] = await Promise.all([ getAllWorkPlaces(), ]);
		const newList = workPlaceListRes.data.data;
		if (Array.isArray(newList)) {
			set({ workPlaceList: newList, });
		} else {
			set({ workPlaceList: [] });
		}
		return newList;
	},
	fetchItemCdCode: async () => {
		const [ itemCdListRes, ] = await Promise.all([ getItemAllList() ]);
		const newMap = new Map<string, ItemDto>();
		itemCdListRes.data.data.forEach((item) => {
			newMap.set(item.itemCd, item);
		});
		set({ itemCdMap: newMap, });
		return newMap;
	},

	plcaddressList: [],
	setPlcaddressList: (data: SysCodeDto[]) => set((state) => { return { ...state, plcaddressList: data } }),
 
	bookMarkCd: '$$$',
	
	//초기화
	initData: () => set((state) => ({
		...state,
		codeInput: '',
		minorCodeList: [],
		selectedMinorCodeList: [],
		deletedMinorCodeList: [],
		filteredMajorCodeList: [],
		selectedMajorCode: undefined,
	})),

	areaCdList: [],
	setAreaCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, areaCdList: data
		}
	}),

	customTypeList: [],
	setCustomTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, customTypeList: data } }),

	autGroupList: [],
	setAutGroupList: (data: SysCodeDto[]) => set((state) => { return { ...state, autGroupList: data } }),

	actionTypeList: [],
	setActionTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, actionTypeList: data } }),

	birthdayTypeList: [],
	setBirthdayTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, birthdayTypeList: data } }),

	bankCdList: [],
	setBankCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, bankCdList: data } }),

	bankAcctTypeList: [],
	setBankAcctTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, bankAcctTypeList: data } }),

	brandCdList: [],
	setBrandCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, brandCdList: data } }),

	countryCdList: [],
	setCountryCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, countryCdList: data } }),

	carTypeList: [],
	setCarTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, carTypeList: data } }),

	carModelList: [],
	setCarModelList: (data: SysCodeDto[]) => set((state) => { return { ...state, carModelList: data } }),

	compJoinTpList: [],
	setCompJoinTpList: (data: SysCodeDto[]) => set((state) => { return { ...state, compJoinTpList: data } }),

	cycleList: [],
	setCycleList: (data: SysCodeDto[]) => set((state) => { return { ...state, cycleList: data } }),

	devStsList: [],
	setDevStsList: (data: SysCodeDto[]) => set((state) => { return { ...state, devStsList: data } }),

	dashboardTypeList: [],
	setDashboardTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, dashboardTypeList: data } }),

	devloperList: [],
	setDevloperList: (data: SysCodeDto[]) => set((state) => { return { ...state, devloperList: data } }),

	downtimeValueList: [],
	setDowntimeValueList: (data: SysCodeDto[]) => set((state) => { return { ...state, downtimeValueList: data } }),

	educationTypeList: [],
	setEducationTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, educationTypeList: data } }),

	empstsCdList: [],
	setEmpstsCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, empstsCdList: data } }),

	eqmClassList: [],
	setEqmClassList: (data: SysCodeDto[]) => set((state) => { return { ...state, eqmClassList: data } }),

	eqmTypeList: [],
	setEqmTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, eqmTypeList: data } }),

	eqmStatusList: [],
	setEqmStatusList: (data: SysCodeDto[]) => set((state) => { return { ...state, eqmStatusList: data } }),

	faultyValueList: [],
	setFaultyValueList: (data: SysCodeDto[]) => set((state) => { return { ...state, faultyValueList: data } }),

	okNgList: [],
	setOkNgList: (data: SysCodeDto[]) => set((state) => { return { ...state, okNgList: data } }),

	moldClassList: [],
	setMoldClassList: (data: SysCodeDto[]) => set((state) => { return { ...state, moldClassList: data } }),

	moldTypeList: [],
	setMoldTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, moldTypeList: data } }),

	cleanTypeList: [],
	setCleanTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, cleanTypeList: data } }),

	moneyCdList: [],
	setMoneyCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, moneyCdList: data } }),

	materialIntypeList: [],
	setMaterialIntypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, materialIntypeList: data } }),

	inoutBoundList: [],
	setInoutBoundList: (data: SysCodeDto[]) => set((state) => { return { ...state, inoutBoundList: data } }),

	inoutClassList: [],
	setInoutClassList: (data: SysCodeDto[]) => set((state) => { return { ...state, inoutClassList: data } }),

	inoutMethodList: [],
	setInoutMethodList: (data: SysCodeDto[]) => set((state) => { return { ...state, inoutMethodList: data } }),

	interesttypeList: [],
	setInteresttypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, interesttypeList: data } }),

	inspectionStatusList: [],
	setInspectionStatusList: (data: SysCodeDto[]) => set((state) => { return { ...state, inspectionStatusList: data } }),

	inspectionResultList: [],
	setInspectionResultList: (data: SysCodeDto[]) => set((state) => { return { ...state, inspectionResultList: data } }),
	inspectionRangeList: [],
	setInspectionRangeList: (data: SysCodeDto[]) => set((state) => { return { ...state, inspectionRangeList: data } }),

	inspectionTypeList: [],
	setInspectionTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, inspectionTypeList: data } }),

	inspectionValueList: [],
	setInspectionValueList: (data: SysCodeDto[]) => set((state) => { return { ...state, inspectionValueList: data } }),

	inspectMethodList: [],
	setInspectMethodList: (data: SysCodeDto[]) => set((state) => { return { ...state, inspectMethodList: data } }),

	inspectClassList: [],
	setInspectClassList: (data: SysCodeDto[]) => set((state) => { return { ...state, inspectClassList: data } }),

	itemAccountList: [],
	setItemAccountList: (data: SysCodeDto[]) => set((state) => { return { ...state, itemAccountList: data } }),

	itemGroupList: [],
	setItemGroupList: (data: SysCodeDto[]) => set((state) => { return { ...state, itemGroupList: data } }),

	itemStatusList: [],
	setItemStatusList: (data: SysCodeDto[]) => set((state) => { return { ...state, itemStatusList: data } }),

	jcCdList: [],
	setJcCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, jcCdList: data } }),

	jobTeamList: [],
	setJobTeamList: (data: SysCodeDto[]) => set((state) => { return { ...state, jobTeamList: data } }),

	jjCdList: [],
	setJjCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, jjCdList: data } }),

	jwCdList: [],
	setJwCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, jwCdList: data } }),

	// 3. KPI 구분 상태와 setter를 스토어에 추가
	kpiKeyList: [],
	setKpiKeyList: (data: SysCodeDto[]) => set((state) => { return { ...state, kpiKeyList: data } }),

	layerList: [],
	setLayerList: (data: SysCodeDto[]) => set((state) => { return { ...state, layerList: data } }),

	ordTypeList: [],
	setOrdTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, ordTypeList: data } }),

	paycollectList: [],
	setPaycollectList: (data: SysCodeDto[]) => set((state) => { return { ...state, paycollectList: data } }),

	paycollectTargetList: [],
	setPaycollectTargetList: (data: SysCodeDto[]) => set((state) => {

		// console.log('setPaycollectTargetList data :', data);

		return {
			...state,
			paycollectTargetList: data 
		} 
	}),

	payTpList: [],
	setPayTpList: (data: SysCodeDto[]) => set((state) => { return { ...state, payTpList: data } }),

	platingTypeList: [],
	setPlatingTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, platingTypeList: data } }),

	programList: [],
	setProgramList: (data: SysCodeDto[]) => set((state) => { return { ...state, programList: data } }),

	retireTypeList: [],
	setRetireTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, retireTypeList: data } }),

	systemList: [],
	setSystemList: (data: SysCodeDto[]) => set((state) => { return { ...state, systemList: data } }),

	testClassCodeList: [],
	setTestClassCodeList: (data: SysCodeDto[]) => set((state) => { return { ...state, testClassCodeList: data } }),

	unitList: [],
	setUnitList: (data: SysCodeDto[]) => set((state) => { return { ...state, unitList: data } }),

	vatTypeList: [],
	setVatTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, vatTypeList: data } }),

	vatIoFlagList: [],
	setVatIoFlagList: (data: SysCodeDto[]) => set((state) => { return { ...state, vatIoFlagList: data } }),

	workProcessList: [],
	setWorkProcessList: (data: SysCodeDto[]) => set((state) => { return { ...state, workProcessList: data } }),

	wmsCdList: [],
	setWmsCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, wmsCdList: data } }),

	wmsInTypeCdList: [],
	setWmsInTypeCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, wmsInTypeCdList: data } }),

	wmsOutTypeCdList: [],
	setWmsOutTypeCdList: (data: SysCodeDto[]) => set((state) => { return { ...state, wmsOutTypeCdList: data } }),

	// 입고분류 (PUR2020_R01 검색조건)
	inoutTypeList: [],
	setInoutTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, inoutTypeList: data } }),

	chemicalTypeList: [],
	setChemicalTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, chemicalTypeList: data } }),
	sparesTypeList: [],
	setSparesTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, sparesTypeList: data } }),

	prodStockTypeList: [],
	setProdStockTypeList: (data: SysCodeDto[]) => set((state) => { return { ...state, prodStockTypeList: data } }),

	yesNoList: [],
	setYesNoList: (data: SysCodeDto[]) => set((state) => { return { ...state, yesNoList: data } }),

	yesNoNumList: [],
	setYesNoNumList: (data: SysCodeDto[]) => set((state) => { return { ...state, yesNoNumList: data } }),

	bankacctCdList: [],
	setBankacctCdList: (data: BankAcctDto[]) => set((state) => { return { ...state, bankacctCdList: data } }),

	bookmarkCdList: [],
	setBookmarkCdList: (data: BookmarkCdList[]) => set((state) => { return { ...state, bookmarkCdList: data } }),

	customCdList: [],
	setCustomCdList: (data: CustomerResponseDto[]) => set((state) => { return { ...state, customCdList: data } }),

	compCdList: [],
	setCompCdList: (data: CompanyDto[]) => set((state) => { return { ...state, compCdList: data } }),

	equipmentCdList: [],
	setEquipmentCdList: (data: EquipmentDto[]) => set((state) => { return { ...state, equipmentCdList: data } }),

	employeeCdList: [],
	setEmployeeCdList: (data: EmployeeDto[]) => set((state) => { return { ...state, employeeCdList: data } }),

	menuCdList: [],
	setMenuCdList: (data: MenuDto[]) => set((state) => { return { ...state, menuCdList: data } }),

	orgCdList: [],
	setOrgCdList: (data: OrganizationDto[]) => set((state) => { return { ...state, orgCdList: data }}),

	warehouseCdList: [],
	setWarehouseCdList: (data: WareHouseDto[]) => set((state) => { return { ...state, warehouseCdList: data } }),

	workPlaceList: [],
	setWorkPlaceList: (data: WorkPlaceDto[]) => set((state) => { return { ...state, workPlaceList: data } }),

	itemCdMap: new Map<string, ItemDto>(),
	setItemCdMap: (data: Map<string, ItemDto>) => set((state) => { return { ...state, itemCdMap: data } }),

	// 검색 조건 초기값
	searchCondition: {
		majorCd: '',
		minorCd: '',
		codeNm: ''
	},
	setSearchCondition: (condition) => set((state) => ({
		...state,
		searchCondition: {
			...state.searchCondition,
			...condition
		}
	})),
	resetSearchCondition: () => set((state) => ({
		...state,
		searchCondition: {
			majorCd: '',
			minorCd: '',
			codeNm: ''
		}
	})),

	// 상세코드 옵션 관련
	minorCodeOptions: [],
	setMinorCodeOptions: (options) => set((state) => ({
		...state,
		minorCodeOptions: options
	})),
	fetchMinorCodeOptions: async (majorCd) => {
		try {
			const response = await getMinorCodeList(majorCd);
			if (response?.data?.data) {
				set((state) => ({
					...state,
					minorCodeOptions: response.data.data
				}));
			}
		} catch (error) {
			console.error('상세코드 조회 실패:', error);
			set((state) => ({
				...state,
				minorCodeOptions: []
			}));
		}
	},

	// 검색조건용 상세코드 관련
	conditionCodeOptions: [],
	setConditionCodeOptions: (options) => set((state) => ({
		...state,
		conditionCodeOptions: options
	})),
	fetchConditionCodeOptions: async (majorCd) => {
		try {
			const response = await getConditionCodeList(majorCd);
			if (response?.data?.data) {
				set((state) => ({
					...state,
					conditionCodeOptions: response.data.data
				}));
			}
		} catch (error) {
			console.error('검색조건용 상세코드 조회 실패:', error);
			set((state) => ({
				...state,
				conditionCodeOptions: []
			}));
		}
	},

	// 메이저코드 드롭다운 옵션 관련
	majorCodeOptions: [],
	setMajorCodeOptions: (options) => set((state) => ({
		...state,
		majorCodeOptions: options
	})),
	fetchMajorCodeOptions: async () => {
		try {
			const response = await getMajorCodeOptions();
			if (response?.data?.data) {
				set((state) => ({
					...state,
					majorCodeOptions: response.data.data
				}));
			}
		} catch (error) {
			console.error('메이저코드 옵션 조회 실패:', error);
			set((state) => ({
				...state,
				majorCodeOptions: []
			}));
		}
	},
}));
